import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { gradingAPI } from "../api";
import { getErrorMessage } from "../utils/apiError";
import { useAuth } from "./AuthContext";

const GradingSystemContext = createContext(null);

export function GradingSystemProvider({ children }) {
  const { user } = useAuth();
  const [gradingSystem, setGradingSystem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchGradingSystem = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const data = await gradingAPI.getGradingSystem();
      setGradingSystem(data ?? null);
    } catch (err) {
      setGradingSystem(null);
      setError(getErrorMessage(err, "دریافت سیستم نمره‌دهی ناموفق بود"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchGradingSystem();
      return;
    }

    setGradingSystem(null);
    setLoading(false);
    setError("");
  }, [user, fetchGradingSystem]);

  return (
    <GradingSystemContext.Provider
      value={{
        gradingSystem,
        loading,
        error,
        refetch: fetchGradingSystem,
      }}
    >
      {children}
    </GradingSystemContext.Provider>
  );
}

export function useGradingSystem() {
  const context = useContext(GradingSystemContext);

  if (!context) {
    throw new Error("useGradingSystem must be used within GradingSystemProvider");
  }

  return context;
}
